import { createSelector } from 'reselect'
import { isBancAgent } from 'identity/selectors'
import { getLegalDisclaimerEndDate } from 'quick-quote/product-whole-life/benefit-illustration/selectors'
import { getcoveragePlanStartDate } from 'quick-quote/product-common/coverage-plan/selectors'

export const getLegalConditionDisclaimer = createSelector(
  getcoveragePlanStartDate,
  getLegalDisclaimerEndDate,
  isBancAgent,
  (getcoveragePlanStartDate, getLegalDisclaimerEndDate, isBancAgent) => ({
    startDate: getcoveragePlanStartDate,
    endDate: getLegalDisclaimerEndDate,
    isBancAgent,
  })
)
